angular.module('leanlaw').controller('TrustReportSidebarCtrl', ['$scope', '$rootScope', 'userService', function ($scope, $rootScope, userService) {
  $scope.filter = {
    include: {
      zeros: false,
      red: false,
      replenish: true
    },
    trustAccount: null
  };
  userService.me().then(me => {
    const {
      settings
    } = me.company;
    if (settings.clientBilling && !settings.clientBilling.billClient) {
      // show matters if matter billing is default (otherwise all relevant trust/evergreen balances will be hidden)
      $scope.filter.include.matters = true;
    }
    $scope.accountOptions = settings.trust.accounts;
    if ($scope.accountOptions.length === 1) {
      $scope.filter.trustAccount = $scope.accountOptions[0];
    }
    $scope.evergreen = settings.trust.evergreen;
  });
  // $scope.filter.include.accounting = false;

  // Fires immediately on filter creation
  $scope.$watch("filter", () => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);